export default class BaseModel {
    is_dirty = false;
    
    isEmpty(data) {
        return data == null || typeof (data) == 'undefined' || Object.keys(data).length === 0;
    }    
}